import { render, staticRenderFns } from "./ToastSelfie.vue?vue&type=template&id=0a33e009"
import script from "./ToastSelfie.vue?vue&type=script&lang=js"
export * from "./ToastSelfie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports